import { useQuery } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import { IUserSessionResponseData } from "models/users.models";
import { services } from "services";
import { QueryAPIKey } from "utils/constants/api.constants";
import { TErrorData } from "utils/types";

const useSessionCheck = (options?: { enabled: boolean }) => {
  const { isLoading, data } = useQuery<
    AxiosResponse<IUserSessionResponseData>,
    AxiosError<TErrorData>,
    IUserSessionResponseData
  >({
    queryKey: [QueryAPIKey.GetUserSession],
    queryFn: () => services.auth.isAuthenticated(),
    select: ({ data }) => data,
    ...options,
  });

  return {
    isLoading: isLoading,
    isAuthenticated: data?.isAuthenticated,
  };
};

export default useSessionCheck;
